<template>
    <div class="vx-row">
        <div class="vx-col w-full mt-2 pl-0">
            <div class="vx-card p-6 mt-2 height-card-graphic" @mouseover="topicCardHover" @mouseout="topicCardOut">
                <div class="component">
                    <span class="text-title-shades">
                    {{ $t("title.gender") }}
                    <div v-if="!showBarChart" class="lds-facebook">
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    </span>
                </div>
                <div class="component">
                    <span class="text-time-title">
                        {{ countDays }} {{ $t("day")}}
                        <span v-if="countDays > 1 && $i18n.locale == 'en'">s
                        </span>
                    </span>
                </div>
                <div id="chart" :class="{'topic-scroll-graphic' : topicHover,'topic-hidden-demo-graphic': !topicHover}">
                    <vue-apex-charts 
                        v-if="showBarChart"
                        type="bar" 
                        height="700" 
                        :options="barChartShades.chartOptions" 
                        :series="barChartShades.series">
                    </vue-apex-charts>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
export default {
    components: {
        VueApexCharts
    },
    props: {
        dateRange: {
            type: Object
        },
    },
    data(){
        return {
            showBarChart: false,
            topicHover: false,
            countDays: 0,

            barChartShades: {
                series: [],
                chartOptions: {
                    chart: {
                        type: 'bar',
                        stacked: true,
                        // stackType: '100%'
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            horizontal: true,
                        }
                    },
                    stroke: {
                        width: 1,
                        colors: ['#fff']
                    },
                    fill: {
                        opacity: 1
                    },
                    colors: [
                        '#007AFE',
                        '#F12B2C',
                        '#FEC400'
                    ],
                    dataLabels: {
                        enabled: true,
                        style: {
                            colors: ['#fff']
                        }
                    },
                    xaxis: {
                        categories: [],
                        labels: {
                            formatter: function (val) {
                                if (val >= 1000) return val/1000 + 'K';
                                return val;
                            }
                        }
                    },
                    tooltip: {
                        y: {
                            formatter: function (val) {
                                if (val >= 1000) return (val/1000).toFixed(1) + 'K'
                                return val;
                            }
                        }
                    },
                    legend: {
                        show: false,
                        position: "bottom",
                        // offsetX: 0,
                        // offsetY: 50
                        markers: {
                        fillColors: [
                            "#2F7FED",
                            "#003F94",
                            "#F2994A",
                            "#F2C94C",
                            "#828282",
                            "#BDBDBD"
                        ]
                        }
                    },
                },
            },
        }
    },
    methods: {
        topicCardHover:function(){
            this.topicHover = true;
        },
        topicCardOut: function(){
            this.topicHover = false
        },
        getShadeByTopic: function(){
            this.showBarChart = false;
            const payload  = {
                from: this.dateRange.startDate,
                to: this.dateRange.endDate,
                topicId: null,
                // topics: this.topics
            }
            this.$processor.post('user-data/get-mention-topic', payload).then((topic) =>  {
                this.heightChartTopic = 0;
                let chartHeight = topic.data.length * 40;
                if (chartHeight < 300) {
                    this.heightChartTopic = 260;
                }else this.heightChartTopic = chartHeight;
                topic.data = topic.data.sort(function(a, b) {
                    if (a.countMention > b.countMention) return -1;
                    if (a.countMention < b.countMention) return 1;
                    return 0;
                });
                this.barChartShades.chartOptions.xaxis.categories = [];
                let labels = [...topic.data.map(x => {
                    return x.topicName;
                })]
                this.barChartShades.chartOptions.xaxis.categories = labels;
                let positive ={
                        name: this.$t('warning.positive'),
                        data: [...topic.data.map(positive => positive.totalPositive)]
                };
                let negative ={
                        name: this.$t('warning.negative'),
                        data: [...topic.data.map(negative => negative.totalNegative)]
                };
                let neutal = {
                        name: this.$t('warning.neutral'),
                        data: [...topic.data.map(neutral => neutral.totalNeutral)]
                };
                this.barChartShades.series = [
                    positive,
                    negative,
                    neutal
                ];
                this.showBarChart = true;
            });
        },
        colorByTopic: function(){
            let colors = ['#33b2df', '#546E7A', '#d4526e', '#13d8aa', '#A5978B', '#2b908f', '#f9a3a4', '#90ee7e','#f48024', '#69d2e7'];  
            return colors;
        },
        countDateRange: function(fromDate, toDate) {
            const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
            const firstDate = new Date(fromDate);
            const secondDate = new Date(toDate);
            const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));
            this.countDays = diffDays;
        },
        initScreen(){
            this.countDateRange(this.dateRange.startDate, this.dateRange.endDate);
            this.getShadeByTopic();
        }   
    },
    created(){
        this.initScreen();
    }
}
</script>

<style lang="scss">
.topic-scroll-graphic{
  margin-top: 0px;
  max-height: 600px;
  overflow-y: scroll !important;
  overflow-x: hidden !important;
  }
.topic-scroll-graphic::-webkit-scrollbar-track {
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
	background-color: #F5F5F5;
  border-radius: 5px;
}

 .topic-scroll-graphic::-webkit-scrollbar {
	width: 10px;
	background-color: #F5F5F5;
}

 .topic-scroll-graphic::-webkit-scrollbar-thumb {
	background-color: #cccccc;
	border: 1px solid #cccccc;
}
.topic-hidden-demo-graphic {
  max-height: 600px;
  overflow-y: hidden;
}
.height-card-graphic {
  height: 700px;
}
.lds-facebook {
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
  top: -3px;
  float: revert;
  padding-left: 25px;
}

.lds-facebook div {
  display: inline-block;
  position: absolute;
  left: 4px;
  width: 3px;
  background: #626262;
  animation: lds-facebook 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
}

.lds-facebook div:nth-child(1) {
  left: 4px;
  animation-delay: -0.24s;
}

.lds-facebook div:nth-child(2) {
  left: 10px;
  animation-delay: -0.12s;
}

.lds-facebook div:nth-child(3) {
  left: 16px;
  animation-delay: 0s;
}
@keyframes lds-facebook {
  0% {
    top: 8px;
    height: 16px;
  }

  50%,
  100% {
    top: 16px;
    height: 4px;
  }
}
</style>